/**
 * Form validation module for the inventor form
 */
class InventorFormValidator {
    constructor(form) {
        this.form = form;
        this.requiredFields = form.querySelectorAll('[required]');
        this.setupValidation();
    }

    setupValidation() {
        // Remove error styling on input
        this.requiredFields.forEach(input => {
            input.addEventListener('input', () => {
                input.classList.remove('field-error');
            });
        });
    }

    /**
     * Validates all required fields in the form
     * @returns {boolean} True if all fields are valid, false otherwise
     */
    validateForm() {
        let isValid = true;
        
        this.requiredFields.forEach(field => {
            if (!field.value.trim()) {
                field.classList.add('field-error');
                isValid = false;
            } else {
                field.classList.remove('field-error');
            }
        });

        return isValid;
    }

    /**
     * Collects form data from the inventor form
     * @returns {Object} Form data object
     */
    collectFormData() {
        return {
            // Personal Information
            firstName: document.getElementById('first-name').value,
            lastName: document.getElementById('last-name').value,
            companyName: document.getElementById('company-name').value,
            streetAddress: document.getElementById('street-address').value,
            city: document.getElementById('city').value,
            stateProvince: document.getElementById('state-province').value,
            countryRegion: document.getElementById('country-region').value,
            postalCode: document.getElementById('postal-code').value,
            phone: document.getElementById('phone').value,
            email: document.getElementById('email').value,
            website: document.getElementById('website').value,
            
            // Concept Information
            submissionName: document.getElementById('submission-name').value,
            description: document.getElementById('description').value,
            submittedElsewhere: document.querySelector('input[name="submitted_elsewhere"]:checked').value,
            
            // Patent and Documentation
            patentStatus: document.querySelector('input[name="patent_status"]:checked').value,
            prototypeSamples: document.querySelector('input[name="prototype_samples"]:checked').value,
            videoDemo: document.querySelector('input[name="video_demo"]:checked').value,
            pitchDeck: document.querySelector('input[name="pitch_deck"]:checked').value
        };
    }

    /**
     * Collects form data from the MNDA form
     * @returns {Object} MNDA form data object
     */
    collectMNDAFormData() {
        const formData = this.collectFormData();
        return {
            ...formData,
            inventorTradeName: document.getElementById('inventor_trade_name').value,
            coordinator: document.getElementById('coordinator').value,
            title: document.getElementById('title').value,
            mndaSignedBy: document.getElementById('mnda_signed_by').value
        };
    }
}

// Export for use in other modules
window.InventorFormValidator = InventorFormValidator;
